import { linkedInAuth } from '@/features/Auth/session/views'

import { CredentialProvider, ProviderFailure } from './types'

export type LinkedInInput = {
  accessToken: string
}

/**
 * LinkedIn resolves server-side and comes back as a custom token.
 *
 * The backend exchanges LinkedIn's access token, resolves or creates the Firebase record
 * under a deterministic uid, and mints a custom token from it. That is already the shape
 * EPIC-004 wants every provider to take — the client never touches the pool — so this one
 * needs no change when the others move.
 */
export const linkedinProvider: CredentialProvider<LinkedInInput> = {
  id: 'linkedin',

  async authenticate({ accessToken }) {
    let response

    try {
      response = await linkedInAuth(accessToken)
    } catch (error) {
      throw new ProviderFailure('linkedin', 'rejected', 'LinkedIn sign-in was refused', { cause: error })
    }

    const { profile, token } = response ?? {}

    if (!token) {
      throw new ProviderFailure('linkedin', 'rejected', 'LinkedIn sign-in returned no token')
    }

    return {
      kind: 'customToken',
      provider: 'linkedin',
      token,
      extras: {
        displayName: [profile?.localizedFirstName, profile?.localizedLastName].filter(Boolean).join(' ') || undefined,
        email: profile?.email
      }
    }
  }
}
